
import {Navbar} from '../../../ui/navigation/navbar/navbar';
import {useUser} from '../use-user';
import {ProgressCircle} from '../../../ui/progress/progress-circle';
import {SocialLoginPanel} from './social-login-panel';
import {BasicInfoPanel} from './basic-info-panel/basic-info-panel';
import {ChangePasswordPanel} from './change-password-panel/change-password-panel';
import {LocalizationPanel} from './localization-panel';
import {AccessTokenPanel} from './access-token-panel/access-token-panel';
import {DangerZonePanel} from './danger-zone-panel/danger-zone-panel';
import {Trans} from '../../../i18n/trans';
import {StaticPageTitle} from '../../../seo/static-page-title';
import {Fragment, useEffect} from 'react';
import {AdminSidebar} from '@common/admin/admin-sidebar';
import {DashboardLayout} from '@common/ui/layout/dashboard-layout';
import {DashboardContent} from '@common/ui/layout/dashboard-content';
import {DashboardSidenav} from '@common/ui/layout/dashboard-sidenav';
import {DashboardNavbar} from '@common/ui/layout/dashboard-navbar';
import {SidebarMenu} from '../../../../../../resources/client/drive/layout/sidebar/sidebar-menu';
import {useAuth} from '@common/auth/use-auth';
import clsx from 'clsx';
import {useSettings} from '@common/core/settings/use-settings';
import {Button} from '@common/ui/buttons/button';
import {Link} from 'react-router-dom';
import {StorageMeter} from '@app/drive/layout/sidebar/storage-summary/storage-meter';
import {Sidebar} from '@app/drive/layout/sidebar/sidebar';
import {useToggleSidebar} from '@app/contexts/toggleSidebar';
import {SvgIcon} from '@common/icons/svg-icon';
export function AccountSettingsPage() {
  const {data, isLoading} = useUser('me', {
    with: ['roles', 'social_profiles', 'tokens'],
  });
  useEffect(()=>{
    if(window.innerWidth<576){
      setShowSidebar(false)
    }else{
      return
    }
  }, [])
  const {showSidebar, setShowSidebar, isdarkMode} = useToggleSidebar();
  return (
    <>
      <div className="bg-alt flex flex-col h-full" style={{overflow: 'hidden'}}>
        <StaticPageTitle>
          <Trans message="Account Settings" />
        </StaticPageTitle>
        <Navbar className="flex-shrink-0" menuPosition="drive-sidebar" />
        <h1
          style={{zIndex: 120000}}
          className=" absolute right-0 top-0 p-5 text-3xl font-extrabold toggle-cross-menu hidden text-white"
        >
          {' '}
          {showSidebar ? (
            <SvgIcon
              onClick={() => {
                setShowSidebar(false);
              }}
            >
              <path
                d="M6 6L18 18M6 18L18 6"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
              />
            </SvgIcon>
          ) : (
            <SvgIcon
              onClick={() => {
                setShowSidebar(true);
              }}
            >
              <path
                d="M3 6h18M3 12h18M3 18h18"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
              />
            </SvgIcon>
          )}
        </h1>
        <div className="main-container">
          {showSidebar && (
            <div className="dashboard-grid-sidenav-left overflow-scroll-y will-change-[width] w-240">
              <Sidebar />
            </div>
          )}
          <div className={`overflow-auto account-container  higt ps `}>
            <div className="my-24 px-24 max-w-1140 ">
              <h1 className="text-3xl">
                <Trans message="Account settings" />
              </h1>
              <div className="mb-40 text-muted text-base">
                <Trans message="View and update your account details, profile and more." />
              </div>
              {isLoading || !data ? (
                <ProgressCircle
                  className="my-80"
                  aria-label="Loading user.."
                  isIndeterminate
                />
              ) : (
                <Fragment>
                  <BasicInfoPanel user={data.user} />
                  <SocialLoginPanel user={data.user} />
                  <ChangePasswordPanel />
                  <LocalizationPanel user={data.user} />
                  {/* <AccessTokenPanel user={data.user} /> */}
                  <DangerZonePanel />
                </Fragment>
              )}
            </div>
          </div>
        </div>

        <div
          style={{
          position: 'absolute',
          bottom: 0,
          width: '100%',
          color: '#fff',
          textAlign: 'center',
          padding: '20px 10px 30px',
          height: '60px',
          fontSize: '14px',
          fontWeight: '400',
          backgroundColor: isdarkMode ? '#202124' : '#006cb6',
          marginTop: '10px',
          zIndex: 20,
        }}
        >
          <Trans message="Ⓒ 2023 - 2025 All Rights Reserved. Designed & Developed by ConiaSoft Ⓡ Yazılım Teknolojileri Limited Şirketi." />
        </div>
      </div>
    </>
  );
}
interface SidebarProps {
  className?: string;
}

// function Sidebar({className}: SidebarProps) {
//   const {isSubscribed} = useAuth();
//   const {billing} = useSettings();
//   return (
//     <div
//       className={clsx(
//         className,
//         'text-sm text-muted font-medium  flex flex-col gap-20 menu overflow-scroll pb-[8.5rem] pt-30 mt-30'
//       )}
//     >
//       <div className="flex-auto">
//         <SidebarMenu />
//         <StorageMeter />
//         {billing.enable && (
//           <div className="pl-60 pb-10">
//             <Button
//               elementType={Link}
//               to={'/pricing'}
//               variant="outline"
//               color="primary"
//               size="xs"
//               className="btn-upgrade"
//             >
//               <Trans message="Upgrade" />
//             </Button>
//           </div>
//         )}
//       </div>
//       {/* <WorkspaceSwitcher /> */}
//     </div>
//   );
// }
